import { Examination_Type } from "@generated/graphql";
import TextFieldControl from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";
import AvailableRangeControl from "../../components/AvailableRangeControl";
import InterviewSwitch from "../../components/InterviewSwitch";
import ReminderSwitch from "../../components/ReminderSwitch";
import ReportSwitch from "../../components/ReportSwitch";

interface GroupAndOpenLeftProps {
  isCreate: boolean;
  examinationType: Examination_Type | undefined;
  isEditing: boolean;
}

const GroupAndOpenLeft = ({ isCreate, examinationType, isEditing }: GroupAndOpenLeftProps) => {
  return (
    <>
      <InterviewSwitch />
      <ReportSwitch />
      <TextFieldControl
        name='title'
        label='Название тестирования'
        rules={{ ...VALIDATION.competencyMapTitle }}
        disabled={!isCreate}
      />
      <TextFieldControl
        name='createdAt'
        label='Дата создания тестирования'
        disabled
      />
      <AvailableRangeControl disabled={!isEditing} />
      {examinationType === Examination_Type.Group && <ReminderSwitch isEditing={isEditing} />}
    </>
  );
};

export default GroupAndOpenLeft;
